import { Skill } from '../skill/skill.model';
import { GoalDownload } from './goal-download.model';

export interface SampleIepGoal {
  title: string;
  description: string;
}

export interface SelStandardsCategory {
  selGoals: string[];
  learningStandards: string[];
  standardizedBenchmarks: string[];
}

export interface SelStandards {
  'elementary-school': SelStandardsCategory;
  'middle-high-school': SelStandardsCategory;
  'pre-k-kindergarten': SelStandardsCategory;
  sampleIepGoals: SampleIepGoal[];
}

export type AgeGroupKey = 'elementary-school' | 'middle-high-school' | 'pre-k-kindergarten';
export type SelStandardsFieldKey = keyof SelStandardsCategory;

// Age groups configuration; defult values as single source of truth
export const SEL_STANDARDS_AGE_GROUPS: Array<{
  key: AgeGroupKey;
  label: string;
}> = [
  { key: 'pre-k-kindergarten', label: 'Pre-K/Kindergarten' },
  { key: 'elementary-school', label: 'Elementary School' },
  { key: 'middle-high-school', label: 'Middle/High School' },
];

export interface Goal {
  icon?: string;
  skill?: Skill;
  slug?: string;
  order: number;
  title: string;
  goalId: string;
  skillId: string;
  iconFile?: File | null;
  videoFile?: File | null;
  subtitle?: string;
  videoLink?: string;
  tags?: Array<string>;
  description?: string;
  videoThumbnail?: string;
  videoThumbnailFile?: File | null;
  curriculum?: { curriculumId: string; title: string };
  downloads?: Array<GoalDownload>;
  selStandards?: SelStandards;
  associatedUnitsByAge?: Array<{
    age: string;
    ageUuid: string;
    ageOrder: number;
    units: Array<{
      id: number;
      unitUuid: string;
      unitTitle: string;
      unitOrder: number;
      unitStatus: string;
      ageUuid: string;
      curriculumUuid: string;
      goalUuid: string;
    }>;
  }>;
}
